import { ComponentType as e } from "../../registries/types/propTypes.js";
const i = (n) => {
  const o = Array.isArray(n == null ? void 0 : n.accordion_component) ? n == null ? void 0 : n.accordion_component[0] : n == null ? void 0 : n.accordion_component, { items: c, section_title: t } = o;
  return {
    componentType: e.accordion_component,
    accordionItemArr: c,
    sectionTitle: t
  };
};
export {
  i as default
};
//# sourceMappingURL=accordion-component-transformer.js.map
